import { rightMonitorReport } from '@/shared/right-utils/rightMonitor';
import { ubtModuleExposeNew, ubtSendError } from '../ubt';
import { RequestDecoratorEnum } from './enum';

/**
 * 根据action 存储请求参数
*/
const REQUEST_SEQUENCE_MAP = new Map();
/**
 * 接口装饰层，用于做一些接口层的公共处理
 * 1. 短时间内可能连续发起的相关请求，可能存在相关网络时序性问题；
 * 2. 避免接口请求失败后，多次请求，造成用户体验问题；
*/
function requestDecorator<T, K>(
  decoratorType: RequestDecoratorEnum,
  requestInstance: () => Promise<T>,
  params: K,
  /** 网关名称 */
  action: string,
): Promise<T & { reqParams: K } | T> {
  REQUEST_SEQUENCE_MAP.set(action, params);
  // 根据需要包裹的接口相关参数返回进行装饰后的接口返回数据
  if (decoratorType === RequestDecoratorEnum.REQUEST_PARAMS) {
    const request = () => new Promise((resolve, reject) => {
      requestInstance().then((res) => {
        resolve(
          {
            ...res, reqParams: params,
          },
        );
      }).catch((err) => {
        // 增加埋点上报，辅助analytics
        rightMonitorReport(
          'request_error',
          {
            errMsg: JSON.stringify(err?.message),
            err: JSON.stringify(err),
            errCode: JSON.stringify(err?.code),
            type: JSON.stringify(err?.type),
          },
        );

        reject(err);
      });
    });

    return new Promise((resolve, reject) => {
      try {
        request().then((res) => {
          if (
            JSON.stringify(REQUEST_SEQUENCE_MAP.get(action))
            === JSON.stringify((res as T & { reqParams: K }).reqParams)
          ) {
            resolve(res as T & K);
          } else {
            rightMonitorReport(
              'request_params_not_match',
              (res as Dictionary)?.reqParams as Dictionary,
            );
            // 增加埋点上报，辅助analytics
            reject(new Error('request params not match!'));
          }
        }).catch((err) => {
          // 增加埋点上报，辅助analytics
          rightMonitorReport(
            'request_error',
            err,
          );
          reject(err);
        });
      } catch (err) {
        throw Error(err as string | undefined);
      }
    });
  }

  return requestInstance();
}

export default requestDecorator;
